import { BaseActivityModel } from '../base-activity.model';
import { WhatsAppRecordModel } from "./whatsapp-record.model";

export interface WhatsAppActivityModel extends BaseActivityModel {
  scheduledTimestamp?: Date;

  whatsAppTemplateName: string;
  whatsAppBodyContent: string;
  whatsAppDocument: boolean;
  whatsAppFooterContent: string;
  whatsAppButton: string;

  whatsAppStatusSent: number;
  whatsAppStatusSkip: number;
  whatsAppStatusRead: number;
  whatsAppStatusDelivered: number;
  whatsAppStatusAcknowledge: number;
  whatsAppStatusFailed: number;

  records: WhatsAppRecordModel[];

  sftp?: boolean;
  sftpPath?: string;
}
